module.exports = __webpack_public_path__ + "static/media/r391.964a5b6a.jpg";